import {
  Grid,
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import React, { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import Home from "../../home/Home";
import { useEffect } from "react";
import OperationReportService from "../../../Services/Reports/OperationReportService";
import { getDate } from "../../Utils/Common";
import Snackbar from "../../Snacbar";
import HashLoader from "react-spinners/HashLoader";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "rgb(61, 195, 177)",
    color: "black",
    textAlign: "center",
    fontFamily: "Times New Roman",
    fontWeight: "bold",
  },
  [`&.${tableCellClasses.body}`]: {
    textAlign: "center",
    fontSize: 14,
    fontFamily: "Times New Roman",
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));
const ItemPap = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  border: " 1px solid black",
  // backgroundColor: "#C8EDE7",
  height: "100%",
}));
const ItemPap1 = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  border: " 1px solid black",
  color: theme.palette.text.secondary,
  backgroundColor: "white",
}));
function ProfitAndLoseReport() {
  const mystyle = {
    border: " 1px solid black",
    width: "11rem",
    fontFamily: "Times New Roman",
  };
  const mystyle1 = {
    fontWeight: "bolder",
    color: "#0b64c5",
    fontFamily: "Times New Roman",
  };
  ///
  const [message, setMessage] = useState("");
  const [open, setOpen] = useState(false);
  const [severit, setseverit] = useState("");
  const [showProcs, setshowProcs] = useState(false);
  const [exportExcelProcs, setexportExcelProcs] = useState(false);
  const [details1, setdetails1] = useState([]);
  const [details2, setdetails2] = useState([]);
  const [loading, setloading] = useState(false);
  const [details3, setdetails3] = useState([]);
  const [details4, setdetails4] = useState([]);
  const [FilteredDetails, setFilteredDetails] = useState([]);
  const [ProfitLosValues, setProfitLosValues] = useState({
    from: getDate(),
    to: getDate(),
    branch: "ALL",
    cust: "ALL",
    port: "ALL",
    job: "",
  });
  const fromhandlechange = (e) => {
    setProfitLosValues({ ...ProfitLosValues, from: e.target.value });
  };
  const tohandlechange = (e) => {
    setProfitLosValues({ ...ProfitLosValues, to: e.target.value });
  };
  const custhandlechange = (e) => {
    setProfitLosValues({
      ...ProfitLosValues,
      cust: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, ""),
    });
  };
  const porthandlechange = (e) => {
    setProfitLosValues({
      ...ProfitLosValues,
      port: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, ""),
    });
  };
  const branchhandlechange = (e) => {
    setProfitLosValues({
      ...ProfitLosValues,
      branch: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, ""),
    });
  };
  const jobhandlechange = (e) => {
    setProfitLosValues({
      ...ProfitLosValues,
      job: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, ""),
    });
  };
  //error message
  const handleClose = () => {
    setOpen(false);
  };
  ///
  const getfunctions = () => {
    OperationReportService.selectBranchDetails().then((res) => {
      setdetails1(res.data);
    });
    OperationReportService.getCustomerBasedCustomerType("Importer").then(
      (res) => {
        setdetails2(res.data);
      },
    );
    OperationReportService.getCustomLocation().then((res) => {
      setdetails3(res.data);
    });
  };
  const showBtnClick = () => {
    setshowProcs(true);
    setloading(true);
    setPage(0);
    var imp_cd,
      reginlCd,
      jobNo,
      frm,
      to = "";
    if (ProfitLosValues.cust === "ALL") {
      imp_cd = "-1";
    } else {
      imp_cd = ProfitLosValues.cust;
    }
    if (ProfitLosValues.branch === "ALL") {
      reginlCd = -1;
    } else {
      reginlCd = ProfitLosValues.branch;
    }
    if (ProfitLosValues.job === "") {
      jobNo = "-1";
      frm = ProfitLosValues.from;
      to = ProfitLosValues.to;
    } else {
      jobNo = ProfitLosValues.job;
      frm = "-1";
      to = "-1";
    }
    let details = {
      importer_iec_no: imp_cd,
      regionalId: reginlCd,
      consignmentNumber: jobNo,
      fromDate: frm,
      toDate: to,
      flag: 1,
    };
    OperationReportService.getProfitReport(details).then((res) => {
      const data = res.data;
      const details = data.map((item) => item);
      if (details[0] === [] || !details[0]) {
        setMessage("No Record Found");
        setseverit("warning");
        setOpen(true);
        setshowProcs(false);
        setloading(false);
      } else {
        setdetails4(res.data);
        setFilteredDetails(res.data);
        setshowProcs(false);
        setloading(false);
      }
    });
  };
  const ExportReportClick = () => {
    setexportExcelProcs(true);
    if (!details4[0]) {
      setMessage("No Record Found");
      setseverit("warning");
      setOpen(true);
      setexportExcelProcs(false);
    } else {
      var tableContent,
        contenall = "";
      console.log(details4);
      for (let i = 0; i < details4.length; i++) {
        if (details4[i].regionalName !== "") {
          tableContent = details4[i].regionalName + "!";
        } else {
          tableContent += "!";
        }
        if (details4[i].importer_name !== "") {
          tableContent += details4[i].importer_name + "!";
        } else {
          tableContent += "!";
        }
        if (details4[i].customPointName !== "") {
          tableContent += details4[i].customPointName + "!";
        } else {
          tableContent += "!";
        }
        if (details4[i].consignmentNumber !== "") {
          tableContent += details4[i].consignmentNumber + "!";
        } else {
          tableContent += "!";
        }
        if (details4[i].invoiceDate !== "") {
          tableContent += details4[i].invoiceDate + "!";
        } else {
          tableContent += "!";
        }
        if (details4[i].billAmt !== "") {
          tableContent += details4[i].billAmt + "!";
        } else {
          tableContent += "!";
        }
        if (details4[i].expenseAmt !== "") {
          tableContent += details4[i].expenseAmt + "!";
        } else {
          tableContent += "!";
        }
        if (details4[i].profitAmt !== "") {
          tableContent += details4[i].profitAmt + "!";
        } else {
          tableContent += "!";
        }
        if (details4[i].lossAmt !== "") {
          tableContent += details4[i].lossAmt + "#";
        } else {
          tableContent += "#";
        }
        contenall += tableContent;
      }
      console.log("contenall => " + JSON.stringify(contenall));
      let details = {
        headerName: "3,0,PROFIT LOSS REPORT",
        headerDetails:
          "1,1,FROM DATE : " +
          ProfitLosValues.from +
          "/4,1,TO DATE : " +
          ProfitLosValues.to,
        tableHeader:
          "0,3,Sl.No/1,3,Branch Name/2,3,Customer Name/3,3,Clearance Port/4,3,Job No/5,3,Job Date/6,3,Bill Amount/7,3,Expense Amount/8,3,Profit/9,3,Loss",
        tableRowStartsFrom: 4,
        tableColumnStartsFrom: 0,
        fileCode: "ProfitLoss",
        totalNumberOfColumn: 10,
        tableContent: contenall.substring(0, contenall.length - 1),
      };
      OperationReportService.Excelwrite(details).then((res) => {
        const filename = res.data.message;
        // window.open('http://localhost:8080/ExportFiles/' + filename.toString(), "_blank")
        window.open(
          "http://35.154.221.117:8081/ExportFiles/" + filename.toString(),
          "_blank",
        );
      });
    }
    setexportExcelProcs(false);
  };
  useEffect(() => {
    setloading(true);
    setTimeout(() => {
      setloading(false);
    }, 1000);
    getfunctions();
  }, []);

  ///table search
  const brnchSrch = () => {
    return (
      <input
        style={{ width: "80px", textAlign: "center", fontSize: "12px" }}
        placeholder="Search"
        onChange={(e) => {
          brnchOnchange(e.target.value);
        }}
      />
    );
  };
  const cusNmSrch = () => {
    return (
      <input
        style={{ width: "80px", textAlign: "center", fontSize: "12px" }}
        placeholder="Search"
        onChange={(e) => {
          cusNmchange(e.target.value);
        }}
      />
    );
  };
  const jobNoSrch = () => {
    return (
      <input
        style={{ width: "80px", textAlign: "center", fontSize: "12px" }}
        placeholder="Search"
        onChange={(e) => {
          jobNoOnchange(e.target.value);
        }}
      />
    );
  };
  const brnchOnchange = (searchedVal) => {
    const filteredvalue = details4.filter((trns) => {
      return trns.regionalName
        .toString()
        .toLowerCase()
        .includes(searchedVal.toLowerCase());
    });
    if (filteredvalue.length < 1) {
      setFilteredDetails(details4);
    } else {
      setFilteredDetails(filteredvalue);
    }
  };
  const cusNmchange = (searchedVal) => {
    const filteredvalue = details4.filter((trns) => {
      return trns.importer_name
        .toString()
        .toLowerCase()
        .includes(searchedVal.toLowerCase());
    });
    if (filteredvalue.length < 1) {
      setFilteredDetails(details4);
    } else {
      setFilteredDetails(filteredvalue);
    }
  };
  const jobNoOnchange = (searchedVal) => {
    const filteredvalue = details4.filter((trns) => {
      return trns.consignmentNumber
        .toString()
        .toLowerCase()
        .includes(searchedVal.toLowerCase());
    });
    if (filteredvalue.length < 1) {
      setFilteredDetails(details4);
    } else {
      setFilteredDetails(filteredvalue);
    }
  };
  //paginationCodes

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  return (
    <div>
      <Home />
      <div style={{ paddingLeft: "80px" }}>
        <Snackbar
          open={open}
          message={message}
          severity={severit}
          onClose={handleClose}
        />
        {loading ? (
          <div className="loaderCss">
            <HashLoader
              color={"#296cbc"}
              loading={loading}
              size={50}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div>
        ) : (
          <ItemPap>
            <Grid>
              <div
                className="Billingtitleclr"
                style={{
                  color: "red",
                  fontWeight: "bold",
                  fontSize: "25px",
                  marginTop: "1%",
                  marginBottom: "1%",
                }}
              >
                <center>PROFIT LOSS REPORT</center>
              </div>
              <Row>
                <Col>
                  <label style={mystyle1}>From Date</label>
                </Col>
                <Col>
                  <Form.Control
                    size="sm"
                    type="date"
                    style={mystyle}
                    value={ProfitLosValues.from}
                    onChange={fromhandlechange}
                  />
                </Col>
                <Col>
                  <label style={mystyle1}>To Date</label>{" "}
                </Col>
                <Col>
                  <Form.Control
                    size="sm"
                    type="date"
                    style={mystyle}
                    value={ProfitLosValues.to}
                    onChange={tohandlechange}
                  />
                </Col>
                <Col>
                  <label style={mystyle1}>Job No</label>{" "}
                </Col>
                <Col>
                  <Form.Control
                    size="sm"
                    type="text"
                    style={mystyle}
                    value={ProfitLosValues.job}
                    onChange={jobhandlechange}
                  />
                </Col>
              </Row>
              <Row className="mt-1">
                <Col>
                  <label style={mystyle1}>Branch Name</label>{" "}
                </Col>
                <Col>
                  <Form.Select
                    size="sm"
                    style={mystyle}
                    value={ProfitLosValues.branch}
                    onChange={branchhandlechange}
                  >
                    <option value={"ALL"}>ALL</option>
                    {details1.map((trns) => (
                      <option value={trns.regionId}>{trns.regionalName}</option>
                    ))}
                  </Form.Select>
                </Col>
                <Col>
                  <label style={mystyle1}>Customer</label>{" "}
                </Col>
                <Col>
                  <Form.Select
                    type="text"
                    list="code"
                    style={mystyle}
                    size="sm"
                    value={ProfitLosValues.cust}
                    onChange={custhandlechange}
                  >
                    <option value={"ALL"}>ALL</option>
                    {details2.map((trns) => (
                      <option value={trns.importer_iec_no}>
                        {trns.importer_name}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
                <Col>
                  <label style={mystyle1}>ClearancePort</label>{" "}
                </Col>
                <Col>
                  <Form.Select
                    size="sm"
                    style={mystyle}
                    value={ProfitLosValues.port}
                    onChange={porthandlechange}
                  >
                    <option value={"ALL"}>ALL</option>
                    {details3.map((trns) => (
                      <option value={trns.clearanceLocationCode}>
                        {trns.clearanceLocationName}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
              </Row>
            </Grid>
            <Row className="mt-1 mb-1">
              <Col lg={4}></Col>
              <Col lg={4}>
                <Button
                  variant="primary"
                  style={{ fontFamily: "Times New Roman" }}
                  size="sm"
                  onClick={showBtnClick}
                >
                  {showProcs ? "processing..." : "Show"}
                </Button>{" "}
                <Button
                  variant="success"
                  style={{ fontFamily: "Times New Roman" }}
                  size="sm"
                  onClick={ExportReportClick}
                >
                  {exportExcelProcs ? "processing..." : "Export Excel"}
                </Button>{" "}
              </Col>
              <Col lg={4}></Col>
            </Row>
            <ItemPap1>
              <TableContainer sx={{ height: 410 }} className="mt-1">
                <Table stickyHeader className="table table-bordered">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell>SlNo</StyledTableCell>
                      <StyledTableCell>BranchName{brnchSrch()}</StyledTableCell>
                      <StyledTableCell>
                        CustomerName{cusNmSrch()}
                      </StyledTableCell>
                      <StyledTableCell>ClearancePort</StyledTableCell>
                      <StyledTableCell>JobNo{jobNoSrch()}</StyledTableCell>
                      <StyledTableCell>JobDate</StyledTableCell>
                      <StyledTableCell>BillAmpount</StyledTableCell>
                      <StyledTableCell>ExpenseAmount</StyledTableCell>
                      <StyledTableCell>Profit</StyledTableCell>
                      <StyledTableCell>Lose</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {FilteredDetails.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage,
                    ).map((trns, index) => (
                      <StyledTableRow hover key={trns.serialNumber}>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {trns.serialNumber}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {trns.regionalName}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {trns.importer_name}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {trns.customPointName}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {trns.consignmentNumber}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {trns.invoiceDate}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {trns.billAmt}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {trns.expenseAmt}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {trns.profitAmt}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {trns.lossAmt}
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                showFirstButton
                showLastButton
                component="div"
                count={FilteredDetails.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onChangeRowsPerpage={handleChangeRowsPerPage}
              />
            </ItemPap1>
          </ItemPap>
        )}
      </div>
    </div>
  );
}
export default ProfitAndLoseReport;
